import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="6" y="15" rx="4" ry="4" width="50" height="3" />
      <rect x="6" y="20" rx="3" ry="3" width="100" height="3" />
      <rect x="6" y="40" rx="3" ry="3" width="100" height="3" />
      <rect x="6" y="45" rx="3" ry="3" width="150" height="3" />
      <rect x="6" y="50" rx="3" ry="3" width="125" height="3" />
      <rect x="350" y="15" rx="3" ry="3" width="45" height="15" />
      <rect x="255" y="15" rx="3" ry="3" width="90" height="3" />
      <rect x="285" y="20" rx="3" ry="3" width="60" height="3" />
    </React.Fragment>
  );
};
